import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import templateModel from './templateModel';
import previewModel from './previewFrom/previewModel.vue';
import { dynamicControlList, pageType, dynamicControlStatus } from './request';
import informationModel from '../components/informationModel';
import { mapState, mapMutations } from 'vuex';
export default {
  components: {
    templateModel,
    informationModel,
    previewModel
  },
  data() {
    return {
      form: {},
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      columns: [{
        slots: {
          title: '序号'
        },
        dataIndex: 'index',
        key: '1',
        align: 'center',
        width: 100,
        scopedSlots: {
          customRender: 'index'
        }
      }, {
        slots: {
          title: '模版名称'
        },
        dataIndex: 'name',
        key: '2',
        align: 'center'
      }, {
        slots: {
          title: '页面类型'
        },
        dataIndex: 'pageTypeName',
        key: 'pageTypeName',
        align: 'center',
        scopedSlots: {
          customRender: 'pageTypeName'
        }
      }, {
        slots: {
          title: '状态'
        },
        dataIndex: 'status',
        key: '7',
        align: 'center',
        scopedSlots: {
          customRender: 'status'
        },
        width: 100
      }, {
        slots: {
          title: '创建时间'
        },
        dataIndex: 'createAt',
        key: '5',
        align: 'center'
      }, {
        slots: {
          title: '操作'
        },
        width: 350,
        key: '6',
        align: 'center',
        scopedSlots: {
          customRender: 'action'
        }
      }],
      data: [],
      pageTypeList: [],
      templateShow: false,
      informationShow: false,
      templatPereviewShow: false
    };
  },
  created() {
    this.getDataFun();
    pageType().then(res => {
      this.pageTypeList = res;
    });
  },
  methods: {
    ...mapMutations({
      SET_PAGE_SHOW: 'control/SET_PAGE_SHOW'
    }),
    async getDataFun() {
      const {
        items,
        totalNum
      } = await dynamicControlList(Object.assign(this.form, {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize
      }));
      this.data = items;
      this.pagination.total = totalNum;
    },
    searchFun() {
      this.pagination.current = 1;
      this.getDataFun();
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getDataFun();
    },
    handleEdit(val) {
      this.templateShow = true;
      this.$nextTick(() => {
        this.$refs.templateRef.init(val, this.pageTypeList);
      });
    },
    async checkedFun(val) {
      if (!this.isAuth('home.DynamicControlsEditStatus')) {
        this.$message.error(this.$t('暂无权限'));
        return false;
      }
      const res = await dynamicControlStatus({
        id: val.id,
        status: val.status == 1 ? 0 : 1
      }).catch(err => {
        return false;
      });
      if (res) {
        if (res.status == 1) {
          this.$message.success(this.$t('修改成功'));
          this.getDataFun();
        } else {
          this.informationShow = true;
          this.$nextTick(() => {
            this.$refs.informationRef.init(res.nameArray, 2);
          });
        }
      }
    },
    handlePreview(val) {
      this.templatPereviewShow = true;
      let controlsGroupConfig = JSON.parse(val.controlsGroupConfig);
      console.log(controlsGroupConfig, '-----click yulan---------');
      controlsGroupConfig.controlsConfig.map(item => {
        if (item.controlsMark == 'productList' && item.controlsObject.landingPageModuleDisplay) {
          this.SET_PAGE_SHOW(2);
        }
      });
      this.$nextTick(() => {
        this.$refs.templatPereviewRef.init(val);
      });
    }
  }
};